module.exports = __webpack_public_path__ + "static/img/MM.654ed589.jpg";